export default {
  disasterAuthorization: {
    title: 'Autorización',
    text: 'Seleccione su proveedor de datos e ingrese la clave correspondiente de su usuario de HeiGIT Disaster Portal. Si aún no tiene un usuario, solicite uno enviando un correo electrónico a support[at]openrouteservice.heigit.org, especificando su caso de uso. Incluso sin una clave, la aplicación se puede usar en modo de solo lectura.',
    save: 'Guardar',
    enterTheAuthorizationKey: 'Ingrese la clave aquí',
    selectProvider: 'Seleccione su proveedor de datos',
    useReadOnly: 'Usar en modo lectura',
    authenticateAsAdmin: 'Activar el modo de administración aquí',
    insertAValidKey: 'Se debe insertar una clave válida',
    insertAProvider: 'Se debe elegir un proveedor de datos que coincida con su autorización'
  }
}
